<bit-item-action class="tw-flex tw-flex-1 tw-overflow-hidden" data-item-main-content>
  <ng-content></ng-content>
</bit-item-action>

<div
  #endSlot
  class="tw-px-2 tw-flex tw-items-center tw-gap-2 [&_button[biticonbutton]]:-tw-mx-1"
  [hidden]="endSlot.childElementCount === 0"
>
  <ng-content select="[slot=end]"></ng-content>
</div>
